import React from 'react';

/**
 * Top-level Error Boundary so a React render error doesn't leave the iOS
 * Capacitor WebView showing a blank black screen. Catches errors during
 * rendering, lifecycle methods, and constructors of child components.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log to the JS console so Safari Web Inspector picks it up
    console.error('[CyBoard] Top-level render error:', error, info);
  }

  handleReload = () => {
    try { window.location.href = '/'; } catch { /* ignore */ }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#06060A',
          color: '#fff',
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif',
        }}>
          <div style={{ fontSize: 56, marginBottom: 16 }}>🎲</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Something rolled wrong.</h1>
          <p style={{ color: '#A1A1AA', fontSize: 14, marginTop: 12, maxWidth: 320 }}>
            CyBoard hit an unexpected error while loading. Try reloading — if it keeps
            happening, drop us a line at support@cyboard.games.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              marginTop: 24,
              padding: '12px 24px',
              borderRadius: 12,
              background: 'linear-gradient(135deg,#9D4CDD,#7C3AED)',
              color: '#fff',
              fontWeight: 700,
              fontSize: 14,
              border: 'none',
            }}
          >
            Reload App
          </button>
          {this.state.error?.message && (
            <pre style={{
              marginTop: 32,
              padding: 12,
              background: '#0a0a12',
              border: '1px solid rgba(255,255,255,0.06)',
              borderRadius: 8,
              fontSize: 10,
              color: '#71717A',
              maxWidth: '90%',
              maxHeight: 200,
              overflow: 'auto',
              textAlign: 'left',
              whiteSpace: 'pre-wrap',
            }}>{String(this.state.error.message)}</pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
